module.exports = __webpack_public_path__ + "img/submit.3819edb9.png";